import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';
import Select from 'react-select';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class MarketplaceDeliveryPreferences extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deliveryPreferences: props.formData,
    };

    this.addDeliveryPreference = this.addDeliveryPreference.bind(this);
    this.removeDeliveryPreference = this.removeDeliveryPreference.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      deliveryPreferences: nextProps.formData,
    });
  }

  onChange(index, fieldName) {
    return (event) => {
      const newDeliveryPreferences = this.state.deliveryPreferences;
      newDeliveryPreferences[index][fieldName] = event.target.value;

      this.setState(
        {
          deliveryPreferences: newDeliveryPreferences,
        },
        () => this.props.onChange(this.state.deliveryPreferences)
      );
    };
  }

  addDeliveryPreference() {
    this.setState(
      {
        deliveryPreferences: [
          ...this.state.deliveryPreferences,
          {
            deliveryDay: '',
            deadlineDay: '',
            totalSumLimit: '',
            deadlineHour: 20,
          },
        ],
      },
      () => this.props.onChange(this.state.deliveryPreferences)
    );
  }

  removeDeliveryPreference(index) {
    const newDeliveryPreferences = this.state.deliveryPreferences;
    newDeliveryPreferences.splice(index, 1);
    this.setState(
      {
        deliveryPreferences: newDeliveryPreferences,
      },
      () => this.props.onChange(this.state.deliveryPreferences)
    );
  }

  onDeliveryDayChange(deliveryPreferenceIndex, deliveryDay) {
    const newDeliveryPreferences = this.state.deliveryPreferences;
    newDeliveryPreferences[deliveryPreferenceIndex].deliveryDay = deliveryDay;

    this.setState(
      {
        deliveryPreferences: newDeliveryPreferences,
      },
      () => this.props.onChange(this.state.deliveryPreferences)
    );
  }

  onDeadlineDayChange(deliveryPreferenceIndex, deadlineDay) {
    const newDeliveryPreferences = this.state.deliveryPreferences;
    newDeliveryPreferences[deliveryPreferenceIndex].deadlineDay = deadlineDay;

    this.setState(
      {
        deliveryPreferences: newDeliveryPreferences,
      },
      () => this.props.onChange(this.state.deliveryPreferences)
    );
  }

  render() {
    const deliveryDayOptions = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'].map((day) => {
      return {
        label: this.props.intl.formatMessage({ id: `day.${day}` }),
        value: day,
      };
    });

    const deadlineDayOptions = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'].map((day) => {
      return {
        label: this.props.intl.formatMessage({ id: `day.${day}` }),
        value: day,
      };
    });

    return (
      <div>
        <legend>
          <FormattedMessage id={'delivery.preferences.form.field.legend'} />
        </legend>

        {this.state.deliveryPreferences.map((deliveryPreference, index) => {
          const selectedDeliveryDayValue =
            deliveryDayOptions && deliveryDayOptions.find((option) => option.value === deliveryPreference.deliveryDay);

          const selectedDeadlineValue =
            deadlineDayOptions && deadlineDayOptions.find((option) => option.value === deliveryPreference.deadlineDay);

          return (
            <div key={index} className="marketplace-form__delivery-preferences">
              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'marketplace.form.field.delivery.preferences.field.delivery.day.label'} />
                    </label>
                    <div className="m-b-3">
                      <Select
                        name="form-field-delivery-day"
                        placeholder="Select..."
                        value={selectedDeliveryDayValue}
                        options={deliveryDayOptions}
                        onChange={(day) => this.onDeliveryDayChange(index, day.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'marketplace.form.field.delivery.preferences.field.deadline.day.label'} />
                    </label>
                    <div className="m-b-1">
                      <Select
                        name="form-field-delivery-day"
                        placeholder="Select..."
                        value={selectedDeadlineValue}
                        options={deadlineDayOptions}
                        onChange={(day) => this.onDeadlineDayChange(index, day.value)}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'marketplace.form.field.delivery.preferences.field.deadline.day.help'} />
                    </p>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'marketplace.form.field.delivery.preferences.field.deadline.hour.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={deliveryPreference.deadlineHour}
                        onChange={this.onChange(index, 'deadlineHour')}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'marketplace.form.field.delivery.preferences.field.deadline.hour.help'} />
                    </p>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage
                        id={'marketplace.form.field.delivery.preferences.field.total.sum.limit.label'}
                      />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={deliveryPreference.totalSumLimit}
                        onChange={this.onChange(index, 'totalSumLimit')}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'marketplace.form.field.delivery.preferences.field.total.sum.limit.help'} />
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button onClick={() => this.removeDeliveryPreference(index)} className="btn btn-default btn-small">
                  <FormattedMessage id={'marketplace.form.field.delivery.preferences.remove'} />
                </button>
              </div>
            </div>
          );
        })}

        <div className="marketplace-form__delivery-preferences-add m-b-1" onClick={this.addDeliveryPreference}>
          <small>
            <FontAwesomeIcon icon={faPlusCircle} />{' '}
            <FormattedMessage id={'marketplace.form.field.delivery.preferences.add'} />
          </small>
        </div>
      </div>
    );
  }
}

export default injectIntl(MarketplaceDeliveryPreferences);
